export default "__VITE_ASSET__b19cc482__"